export default __webpack_public_path__ + "static/media/mamut_grid_xl.1e9e6ede.jpg";